module.exports = __webpack_public_path__ + "img/overdue2.c7f17e90.svg";